import React from "react";

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, message: "" });
    }
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || "Route render failed",
    };
  }

  componentDidCatch(error, info) {
    console.error("[ROUTE-ERROR-BOUNDARY]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 12,
            padding: 24,
            background: "#f8fafc",
            color: "#0f172a",
          }}
        >
          <strong>Navigation render failed</strong>
          <span>{this.state.message}</span>
        </div>
      );
    }

    return this.props.children;
  }
}
